module.exports = __webpack_public_path__ + "1.4.15-unryo/img/victorops.4500f8af.png";